import {
    documents,
    time,
    person,
    clipboard,
    car,
    copy,
    ticket,
    wallet,
    card,
    people,
    book,
    informationCircle,
    documentText,
    listCircle,
    hourglass,
    newspaper,
    calendar,
    cube,
    home,
    list,
    barcode,
    shareSocial,
} from "ionicons/icons";

//Chiave localsotrage
const LOCALSTORAGE_KEY = `${process.env.VUE_APP_LOCALSTORAGE_KEY}`;

// Pagina da vedere dopo il login
const pageAfterLogin = "clienti";

// Pulsanti presenti nella dashboard
const dashbordButtons = {
    presenze: true,
    documenti: true,
    richieste: true,
    automezzi: true,
    spese: true,
    tickets: true,
};

// Configurazione del menu
const config_menu = [
    {
        show: true,
        route: "presenze",
        icon: time,
        name: "Presenze",
        allowedRoles: ['Admin', 'Employee', 'Sales Agent']
    },
    {
        show: true,
        route: "documenti",
        icon: documents,
        name: "Documenti",
        allowedRoles: ['Admin', 'Employee', 'Sales Agent']
    },
    {
        show: true,
        route: "richieste",
        icon: clipboard,
        name: "Richieste",
        allowedRoles: ['Admin', 'Employee', 'Sales Agent']
    },
    {
        show: true,
        route: "banca",
        icon: hourglass,
        name: "Banca ore",
        allowedRoles: ['Admin', 'Employee', 'Sales Agent']
    },
    {
        show: true,
        route: "automezzi",
        icon: car,
        name: "Automezzi",
        allowedRoles: ['Admin']
    },
    {
        show: true,
        route: "spese",
        icon: wallet,
        name: "Note spesa",
        allowedRoles: ['Admin', 'Employee', 'Sales Agent']
    },
    {
        show: true,
        route: "calendario",
        icon: calendar,
        name: "Calendario",
        allowedRoles: ['Admin', 'Employee', 'Sales Agent']
    },
    {
        show: true,
        route: "rimborsi",
        icon: card,
        name: "Rimborsi km",
        allowedRoles: ['Admin', 'Employee', 'Sales Agent']
    },
    {
        show: true,
        route: "interventi",
        icon: documentText,
        name: "Interventi",
        allowedRoles: ['Admin', 'Employee', 'Sales Agent']
    },
    {
        show: true,
        route: "tickets",
        icon: ticket,
        name: "Tickets",
        allowedRoles: ['Admin', 'Employee', 'Sales Agent']
    },
    {
        show: true,
        route: "task",
        icon: home,
        name: "Tasks",
        allowedRoles: ['Admin', 'Employee', 'Sales Agent']
    },
    {
        show: true,
        route: "timesheet",
        icon: time,
        name: "Timesheet",
        allowedRoles: ['Admin']
    },
    {
        show: true,
        route: "clienti",
        icon: people,
        name: "Anagrafiche",
        allowedRoles: ['Admin']
    },
    {
        show: true,
        route: "progetti",
        icon: listCircle,
        name: "Progetti",
        allowedRoles: ['Admin']
    },
    {
        show: true,
        route: "leads",
        icon: book,
        name: "Leads",
        allowedRoles: ['Admin']
    },
    {
        show: true,
        route: "bacheca",
        icon: shareSocial,
        name: "Bacheca",
        allowedRoles: ['Admin']
    },
    {
        show: true,
        route: "programma",
        icon: calendar,
        name: "Programma lavoro",
        allowedRoles: ['Admin', 'Employee', 'Sales Agent']
    },
    {
        show: true,
        route: "ordini",
        icon: cube,
        name: "Ordini interni",
        allowedRoles: ['Admin']
    },
    {
        show: true,
        route: "sondaggi",
        icon: newspaper,
        name: "Sondaggi",
        allowedRoles: ['Admin']
    },
    {
        show: true,
        route: "magazzino",
        icon: barcode,
        name: "Magazzino",
        allowedRoles: ['Admin']
    },
    {
        show: true,
        route: "todo",
        icon: list,
        name: "Liste",
        allowedRoles: ['Admin', 'Employee', 'Sales Agent']
    },
    {
        show: true,
        route: "testbarcode",
        icon: list,
        name: "TestBarcode",
        allowedRoles: ['Admin', 'Employee', 'Sales Agent']
    },
    {
        show: true,
        route: "profilo",
        icon: person,
        name: "Profilo",
        allowedRoles: ['Admin', 'Employee', 'Sales Agent']
    },
];

// Configurazione dei permessi per ruolo
const rolePermissions = {
    'Admin': ['*'], // '*' indica accesso a tutte le rotte
    'Employee': ['login', 'presenze', 'documenti', 'richieste', 'banca ore', 'automezzi', 'Nota Spese', 'rimborsi km', 'interventi', 'tickets', 'tasks', 'programma lavoro', 'profilo'],
    'Sales Agent': ['login', 'presenze', 'documenti', 'richieste', 'automezzi', 'spese', 'calendario', 'clienti', 'progetti', 'leads', 'profilo'],
};

export { LOCALSTORAGE_KEY, pageAfterLogin, dashbordButtons, config_menu, rolePermissions };
